import { render } from "./Modal.vue?vue&type=template&id=20d8c70f&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=20d8c70f&scoped=true&lang=css"
import "./Modal.vue?vue&type=style&index=1&id=20d8c70f&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20d8c70f"]])

export default __exports__